export default "/assets/d42df099e57bbe1761c2f976194d3b8f.png";